import { render, staticRenderFns } from "./copycard.vue?vue&type=template&id=00b33d72&scoped=true&"
import script from "./copycard.vue?vue&type=script&lang=js&"
export * from "./copycard.vue?vue&type=script&lang=js&"
import style0 from "./copycard.vue?vue&type=style&index=0&id=00b33d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b33d72",
  null
  
)

export default component.exports